import React, {useState} from 'react'
import {connect} from 'react-redux'
import {storePayload} from '../actions/storePayload.js'
// import alfredSchema from '../Demo_Schema_Flat.json'
import Footer from './Footer.js'
import View from './View.js'
import FileUpload from './FileUpload.js'
import '../styles/FileUpload.css'

function FileUploadContainer(props) {
  const [selectedFile, setSelectedFile] = useState(null)

  function nextStep() {
    props.storePayload({
      step: 'path-select',
    })
  }

  async function onChangeFile(e) {
    const file =
      await e?.target?.files?.length ?
        e?.target?.files[0] :
          e?.dataTransfer?.files?.length ?
            e?.dataTransfer?.files[0] :
              null
    setSelectedFile(file)
  }

  /* Add back in for getting OCR data */
  // function getOCR() {
  //   const myHeaders = new Headers();
  //   myHeaders.append('orgId', process.env.REACT_APP_ORG_ID);
  //   myHeaders.append('authKey', process.env.REACT_APP_AUTH_KEY);

  //   const formdata = new FormData();
  //   const fileType = selectedFile.type
  //   const blob = new Blob([selectedFile], {type: fileType})
  //   formdata.append('file', blob, selectedFile.name)

  //   const url = process.env.REACT_APP_OCR_URL
  //   const requestOptions = {
  //     method: 'POST',
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: 'follow',
  //   }

  //   return fetch(url, requestOptions)
  //       .then(async (res) => {
  //         if (res.ok) {
  //           const text = await res.text()
  //           const result = JSON.parse(text)
  //           props.storePayload({
  //             path: 'path-select',
  //           })
  //           return result
  //         } else {
  //           console.log('error', res)
  //           return null
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err)
  //         return null
  //       })
  // }

  /* Add back in for getting OCR data */
  // async function onSubmit(e) {
  //   e.preventDefault()
  //   props.storePayload({
  //     isLoading: true,
  //   })
  //   let ocrData
  //   if (selectedFile) {
  //     ocrData = await getOCR()
  //   }
  //   handleResponse(ocrData)
  // }

  function onSubmit(e) {
    e.preventDefault()
    nextStep()
  }

  /* Add back in for getting OCR data */
  // async function handleResponse(res) {
  //   const jsonRes = JSON.stringify(res)
  //   await props.storePayload({
  //     requirementsDocOCR: jsonRes,
  //     isLoading: false,
  //     userMessage: 'Requirements document saved',
  //     notificationIcon: 'check',
  //     notificationType: 1,
  //     step: 'path-select',
  //   })
  //   if (props.savesProgress) {
  //     // Store to local storage
  //     localStorage.setItem('dataInProgress', jsonRes)
  //     localStorage.setItem('dataSavedAt', Date.now())
  //     localStorage.setItem('path', props.selectedPath)
  //   }
  // }

  return (
    <div id='file-upload-page'>
      <div id='file-upload-content'>
        <header>
          <h2>Requirements Document Upload</h2>
        </header>
        <div className='center-view'>
          {selectedFile ?
            <View
              file={selectedFile}
              onChangeFile={onChangeFile}
            /> :
            <FileUpload
              onChangeFile={onChangeFile}
            />
          }
        </div>
      </div>
      {/* <footer>
        <span
          id='skip-step'
          onClick={nextStep}
        >
          Skip this step
        </span>
        <Button
          text='Continue'
          onClick={onSubmit}
          theme={props.theme}
          width={'14em'}
        />
      </footer> */}
      <Footer
        onClickContinue={selectedFile ? onSubmit : null}
        skip={nextStep}
        theme={props.theme}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(FileUploadContainer)
